// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__22FJN","buttons":"RemoveExpirationActionButtons_buttons__22z42"};